import { Component, OnInit, OnDestroy } from '@angular/core';
import { LayoutService } from './layouts/layout.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { filter, Subscription } from 'rxjs';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'vita-gist';
  showLayout: boolean = true;

  // Static no-layout routes (exact match)
  // Old (pre-/consumer) paths are kept alongside the new ones since they
  // still exist in the router as redirect stubs — harmless to keep both.
  private noLayoutRoutes = [
    '/login', '/register', '/mail-verification', '/forgot-password',
    '/reset-password', '/home', '/search-results', '/bookslot',
    '/checkout', '/videoconsult', '/legal-verification',
    // New /consumer-prefixed equivalents
    '/consumer', '/consumer/login', '/consumer/register', '/consumer/mail-verification',
    '/consumer/forgot-password', '/consumer/reset-password', '/consumer/search-results',
    '/consumer/bookslot', '/consumer/checkout', '/consumer/videoconsult',
    '/consumer/legal-verification'
  ];

  // Dynamic no-layout prefixes (startsWith match) — covers /firm/:id
  private noLayoutPrefixes = ['/firm/', '/consumer/firm/'];

  private authSubscription: Subscription = new Subscription();
  private routerSubscription: Subscription = new Subscription();
  isDisplayDashboard: boolean = true;
  path: any;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public layoutService: LayoutService,
    private authService: AuthService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects.split('?')[0];
        console.log('currentRoute', currentRoute);

        const isNoLayout =
          this.noLayoutRoutes.includes(currentRoute) ||
          this.noLayoutPrefixes.some(prefix => currentRoute.startsWith(prefix));

        this.isDisplayDashboard = !isNoLayout;

        if (!this.isDisplayDashboard) {
          // For dynamic routes like /firm/abc → path becomes 'firm'
          // For exact routes like /bookslot → path becomes 'bookslot'
          // Normalize the new '/consumer/...' routes back to their original
          // shape first, so `path` resolves to the same value as before the
          // /consumer prefix existed (e.g. '/consumer/login' → 'login',
          // '/consumer/firm/abc' → 'firm'). The bare '/consumer' route is
          // home itself.
          let routeForPath = currentRoute;
          if (currentRoute === '/consumer') {
            routeForPath = '/home';
          } else if (currentRoute.startsWith('/consumer/')) {
            routeForPath = currentRoute.replace('/consumer/', '/');
          }
          const stripped = routeForPath.replace('/', '').split('/')[0];
          this.path = stripped;
        } else {
          this.path = null;
        }
      }
    });
  }

  ngOnInit() {
    this.isDisplayDashboard = false;
    if (isPlatformBrowser(this.platformId)) {
      if (
        window.location.pathname === '/login' ||
        window.location.pathname === '/consumer/login' ||
        window.location.pathname === '/consumer' ||
        window.location.pathname === '/'
      ) {
        this.isDisplayDashboard = false;
        this.path = 'login';
      } else {
        this.isDisplayDashboard = true;
      }
    }
  }

  ngOnDestroy() {
    if (this.authSubscription) this.authSubscription.unsubscribe();
    if (this.routerSubscription) this.routerSubscription.unsubscribe();
  }

  private checkAuthStatus() {
    this.authSubscription = this.authService.currentUser.subscribe((user: any) => {
      console.log('AuthService - User:', user);

      if (user) {
        this.showLayout = true;
        if (this.router.url === '/login' || this.router.url === '/consumer/login') {
          console.log('Redirecting to calendar...');
          this.router.navigate(['/consumer/appointments']);
        }
      } else {
        this.showLayout = false;
        const current = this.router.url.split('?')[0];
        const isNoLayout =
          this.noLayoutRoutes.includes(current) ||
          this.noLayoutPrefixes.some(p => current.startsWith(p));
        if (!isNoLayout) {
          console.log('Redirecting to login...');
          this.router.navigate(['/consumer/login']);
        }
      }
    });
  }
}